import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ICommissionAnalyticsSingle, ICommissionList } from "../models/commission-interface";
import { BehaviorSubject } from "rxjs";
import moment from "moment";

@Injectable({
  providedIn: "root",
})

export class CommissionService {
  public onDetailEconomicChange: BehaviorSubject<any>;
  constructor(private _httpClient: HttpClient) {
    this.onDetailEconomicChange = new BehaviorSubject([]);
  }

  async getCommissions(year: number = moment().year()) {
    return this._httpClient.get<ICommissionList[]>(`/commission?year=${year}`).toPromise();
  }

  async getAnalyticsCommissions(start_date: any, end_date: any) {
    return this._httpClient.get<ICommissionAnalyticsSingle[]>(`/commission/analytics/${start_date}/${end_date}`).toPromise();
  }

  async getCommission(id: number) {
    return this._httpClient.get(`/commission/${id}`).toPromise();
  }

  async addCommission(data: any = {}) {
    return this._httpClient.post("/commission", data).toPromise();
  }

  async editCommission(id: number, data: any = {}) {
    return this._httpClient.put(`/commission/${id}`, data).toPromise();
  }

  async deleteCommission(id: number) {
    return this._httpClient.delete(`/commission/${id}`).toPromise();
  }

  //Function for reopen or close a commission
  async editStatusCommission(id: number, data: any = {}) {
    return this._httpClient.put(`/commission/status/${id}`, data).toPromise();
  }

  async reloadCommissionAnalytics(order_id: number, month: number, year: number) {
    return this._httpClient.put(`/commission/reload-analytics/${order_id}/${month}/${year}`, {}).toPromise();
  }

  async addNewOrder(data: any = {}) {
    return this._httpClient.post("/order/child", data).toPromise();
  }

  async editNewOrder(order_id: number, data: any = {}) {
    return this._httpClient.put(`/order/child/${order_id}`, data).toPromise();
  }

  async deleteNewOrder(id: number) {
    return this._httpClient.delete(`/order/child/${id}`).toPromise();
  }
}
